import { MutationKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import type { SignInRequest, SignInResponse } from '../../types';
import { authApi } from '../../authApi';
import { useAuthSignIn } from '@entities/auth/hooks/useSignIn';

export const useSignIn = (): UseMutationResult<
  SignInResponse,
  AxiosError<TFormErrorResponse>,
  SignInRequest
> => {
  const signIn = useAuthSignIn();

  return useMutation({
    mutationKey: [MutationKey.AUTH_LOGIN],
    mutationFn: data => authApi.signIn(data),
    onSuccess: ({ data, meta }) => {
      signIn({
        tokenExpiresIn: data.expiresIn,
        token: data.accessToken,
        tokenType: data.tokenType,
        refreshToken: data.refreshToken,
        ...meta.user,
      });
    },
  });
};
